const styles = {
  sectionLabel: { fontSize: 16 },
  subLabel: { fontSize: 12 },
  alignCenter: { display: "flex", alignItems: "center" },
  identificationText: { fontWeight: "700" },
};

export default styles;
